import { render, staticRenderFns } from "./SearchFilteredProducts.vue?vue&type=template&id=87b54a0e&scoped=true&"
import script from "./SearchFilteredProducts.vue?vue&type=script&lang=js&"
export * from "./SearchFilteredProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87b54a0e",
  null
  
)

export default component.exports